import { ANMELDEPROBLEM_TEXTE, anmeldeproblemZaehler } from './hilfeTexte';

// „Problem bei der Anmeldung?“ (Profil-Nachbau F-21, F21-5; PF-332): reine Funktionen für AnmeldeProblem.tsx,
// AnmeldeProblemBestaetigt.tsx und Login.tsx – Prüfung im Browser, Abbildung der Antworten des Servers (routes/publicHilfe.ts,
// support/anmeldeproblem.ts) auf die Sätze der Seite und der Token aus der Adresse. Ohne JSX, ohne Netz.
const T = ANMELDEPROBLEM_TEXTE;
export const BESCHREIBUNG_MIN = 10;
export const BESCHREIBUNG_MAX = 4000;
export const ZAEHLER_AB = 3600;
/** Name des Parameters im Link der Bestätigungsmail (/login?anmeldeproblem=<token>). */
export const TOKEN_PARAMETER = 'anmeldeproblem';
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Wie der Server ihn erzeugt (randomBytes(32) als base64url); der Server nimmt 20 bis 200 Zeichen.
const TOKEN = /^[A-Za-z0-9_-]{20,200}$/;

export type FeldFehler = { email?: string; beschreibung?: string };
/** Vor dem Senden: E-Mail-Format (höchstens 254 Zeichen) und mindestens 10 Zeichen Beschreibung; mehr als 4.000 verhindert das
 *  Feld selbst (maxLength). */
export function pruefeMeldung(email: string, beschreibung: string): FeldFehler {
  const fehler: FeldFehler = {};
  const adresse = email.trim();
  if (adresse.length > 254 || !EMAIL.test(adresse)) fehler.email = T.emailFalsch;
  if (beschreibung.trim().length < BESCHREIBUNG_MIN) fehler.beschreibung = T.zuKurz;
  return fehler;
}
export const hatFehler = (fehler: FeldFehler) => !!(fehler.email || fehler.beschreibung);

/** Zähler unter der Beschreibung ab 3.600 Zeichen, „{n} von 4.000 Zeichen“ mit Tausenderpunkt; darunter null. */
export function zaehler(laenge: number): string | null {
  return laenge >= ZAEHLER_AB ? anmeldeproblemZaehler(String(laenge).replace(/\B(?=(\d{3})+(?!\d))/g, '.')) : null;
}

/** Status und Körper einer Fehlerantwort von apiClient; ohne Antwort (Netz, Abbruch) beide null. */
export function antwortVon(error: unknown): { status: number | null; daten: unknown } {
  const antwort = (error as { response?: { status?: unknown; data?: unknown } } | null)?.response;
  return { status: typeof antwort?.status === 'number' ? antwort.status : null, daten: antwort?.data ?? null };
}

export type MeldeErgebnis = { art: 'erfolg' } | { art: 'felder'; felder: FeldFehler } | { art: 'fehler'; satz: string };
/** „Anfrage senden“: 202 Erfolg (gleich, ob es ein Konto gibt); 400 mit fields Fehler am Feld; 429 die Grenze je Anschluss; sonst
 *  (auch Netz und Server) der allgemeine Satz. */
export function meldeErgebnis(status: number | null, daten: unknown): MeldeErgebnis {
  if (status === 202) return { art: 'erfolg' };
  if (status === 400) {
    const felder = (daten as { fields?: unknown } | null)?.fields;
    const namen = Array.isArray(felder) ? felder.map(String) : [];
    const fehler: FeldFehler = {};
    if (namen.includes('email')) fehler.email = T.emailFalsch;
    if (namen.includes('beschreibung')) fehler.beschreibung = T.zuKurz;
    if (hatFehler(fehler)) return { art: 'felder', felder: fehler };
  }
  if (status === 429) return { art: 'fehler', satz: T.zuViele };
  return { art: 'fehler', satz: T.fehler };
}

export type BestaetigungsErgebnis = { art: 'erfolg'; referenz: string } | { art: 'abgelaufen' } | { art: 'fehler'; satz: string };
/** „Anfrage bestätigen“: 200 mit Referenz Erfolg; 410 (unbekannt, abgelaufen oder schon benutzt) der Satz zum Link; sonst der
 *  allgemeine Satz. */
export function bestaetigungsErgebnis(status: number | null, daten: unknown): BestaetigungsErgebnis {
  const referenz = (daten as { referenz?: unknown } | null)?.referenz;
  if (status === 200 && typeof referenz === 'string' && referenz) return { art: 'erfolg', referenz };
  if (status === 410) return { art: 'abgelaufen' };
  return { art: 'fehler', satz: T.bestaetigenFehler };
}

/** Der Token aus ?anmeldeproblem=…: null ohne Parameter, '' bei einem Wert in falscher Form (die Seite zeigt dann gleich den Satz
 *  zum abgelaufenen Link und fragt den Server nicht). */
export function tokenAus(search: string): string | null {
  const wert = new URLSearchParams(search).get(TOKEN_PARAMETER);
  if (wert === null) return null;
  return TOKEN.test(wert) ? wert : '';
}
/** Die Abfrage ohne den Token, andere Parameter bleiben; für navigate mit replace, damit er weder im Verlauf noch in einem
 *  Referrer bleibt. */
export function ohneToken(search: string): string {
  const parameter = new URLSearchParams(search);
  parameter.delete(TOKEN_PARAMETER);
  const rest = parameter.toString();
  return rest ? `?${rest}` : '';
}
